import {Injectable} from '@angular/core';
import {PhysicianOptions} from '../../@portal-shared/physician-options';

@Injectable()
export class PhysicianDashboardService {
    dashboard: PhysicianOptions;
}
